import { EphemerisNotation } from './ephemeris-daily.utils';
import { EphemerisBodyKey, isEphemerisBodyKey } from './ephemeris.models';

/** Weergave: de wisseltabel (poort.lijn per moment) of de dagposities (graden om 00:00 UT). */
export type EphemerisMode = 'changes' | 'daily';

/** Weergavevoorkeuren van de ephemeris-pagina (per browser). */
export interface EphemerisViewPrefs {
  /** Verborgen kolommen. */
  readonly hiddenBodies: readonly EphemerisBodyKey[];
  /** Tijden in UT i.p.v. de lokale tijdzone van de browser (enkel de wisseltabel). */
  readonly useUtc: boolean;
  readonly mode: EphemerisMode;
  /** Notatie van de dagposities. */
  readonly notation: EphemerisNotation;
}

export const EPHEMERIS_VIEW_PREFS_STORAGE_KEY = 'egitura.hd.ephemeris.prefs';

/** Chiron en Lilith zijn informatief (geen HD-activatie): standaard uit (wens Steven 2026-10-13). */
export const DEFAULT_EPHEMERIS_VIEW_PREFS: EphemerisViewPrefs = {
  hiddenBodies: ['chiron', 'lilith'],
  useUtc: false,
  mode: 'changes',
  notation: 'degrees',
};

/** Leest de voorkeuren; valt terug op de defaults bij ontbrekende, kapotte of geblokkeerde opslag. */
export function loadEphemerisViewPrefs(): EphemerisViewPrefs {
  try {
    const raw = localStorage.getItem(EPHEMERIS_VIEW_PREFS_STORAGE_KEY);
    if (!raw) return DEFAULT_EPHEMERIS_VIEW_PREFS;
    const parsed = JSON.parse(raw) as { hiddenBodies?: unknown; useUtc?: unknown; mode?: unknown; notation?: unknown };
    const hiddenBodies = Array.isArray(parsed.hiddenBodies)
      ? parsed.hiddenBodies.filter((key): key is EphemerisBodyKey => typeof key === 'string' && isEphemerisBodyKey(key))
      : DEFAULT_EPHEMERIS_VIEW_PREFS.hiddenBodies;
    return {
      hiddenBodies,
      useUtc: parsed.useUtc === true,
      mode: parsed.mode === 'daily' ? 'daily' : 'changes',
      notation: parsed.notation === 'zodiac' ? 'zodiac' : 'degrees',
    };
  } catch {
    return DEFAULT_EPHEMERIS_VIEW_PREFS;
  }
}

export function saveEphemerisViewPrefs(prefs: EphemerisViewPrefs): void {
  try {
    localStorage.setItem(EPHEMERIS_VIEW_PREFS_STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    // Opslag geblokkeerd (privévenster e.d.): de voorkeur geldt dan enkel voor deze sessie.
  }
}
